import React from "react"
import { Link, graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { rhythm, scale } from "../utils/typography"
import FooterBio from "./blog-post-footer"
//#FFCA28
const BlogPostTemplate = ({ data, pageContext, location }) => {
  const post = data.markdownRemark
  const navigation = (
    <ul style={{ listStyleType: `none`, marginLeft: 0, textAlign: "start" }}>
      <li style={{ display: `inline`, marginRight: 15 }}>
        <Link
          style={{
            color: "#5F5F5F",
            fontSize: "16px",
            fontWeight: "bold",
            fontFamily: `Montserrat, sans-serif`,
          }}
          to={`/`}
        >
          Home
        </Link>
      </li>
      <li style={{ display: `inline`, marginRight: 15 }}>
        <Link
          style={{
            color: "#5F5F5F",
            fontSize: "16px",
            fontFamily: `Montserrat, sans-serif`,
            fontWeight: "bold",
          }}
          to={`/about`}
        >
          About
        </Link>
      </li>
      <li style={{ display: `inline`, marginRight: 0 }}>
        <Link
          style={{
            color: "#5F5F5F",
            fontSize: "16px",
            fontFamily: `Montserrat, sans-serif`,
            fontWeight: "bold",
          }}
          to={`/posts`}
        >
          Blog
        </Link>
      </li>
    </ul>
  )
  return (
    <Layout location={location} title={post.frontmatter.title} url={location.pathname}>
      <SEO
        title={post.frontmatter.title}
        description={post.frontmatter.description || post.excerpt}
      />

      <article>
        <header>
          <p
            style={{
              color: "#1DA1F2",
              fontFamily: `Montserrat, sans-serif`,
              fontSize: `16px`,
              marginBottom: 10,
            }}
          >
            {post.frontmatter.topic}
          </p>
          <p
            style={{
              ...scale(-1 / 5),
              display: `block`,
              marginBottom: rhythm(1),
              fontFamily: `Montserrat, sans-serif`,
              color: "#1DA1F2",
              fontSize: "15px",
              textAlign: `end`,
            }}
          >
            {navigation}
            {post.frontmatter.date}
          </p>
        </header>

        <section
          style={{
            fontFamily: `Montserrat, sans-serif`,
            textAlign: `justify`,
            textJustify: `inter-word`,
            color: `#5F5F5F`,
          }}
          dangerouslySetInnerHTML={{ __html: post.html }}
        />
        <hr
          style={{
            marginBottom: rhythm(1),
            fontFamily: `Montserrat, sans-serif`,
          }}
        />
        <footer>
          <FooterBio />
        </footer>
      </article>
    </Layout>
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        description
        topic
      }
    }
  }
`
